import React from "react";
import * as d3 from "d3"
import exampleData from "../../data/mesh.json"
import { Spin, Space, Progress } from "antd";
export default class Graph extends React.Component{
    static classObj;
    state = {
        data:{
            nodes:[],
            links:[]
        },
        pending:false,
        progress:0,
        edgeNumber:0
    }
    constructor(){
        super();
        Graph.classObj= this;
    }
    replace=(mydata)=>{
        let data = mydata
        let pending = false;
        let edgeNumber = 0;
        this.setState({data,pending,edgeNumber})
    }

    componentDidUpdate(){
        let {data,pending} = this.state;
        if(pending){
            data = {
                nodes:[],
                links:[]
            }
            console.log("++++++++++++++++++++++++++执行了吗11111",this.state.pending)
            //this.increase()
        }else{
            this.drawGraph(data)
        }

    }
    increase = ()=>{
        let self = this;
        let timer = null;
        setTimeout(function f(){
            if(self.state.pending){
                let {progress} = self.state;
                progress +=10;
                self.setState({progress});
            }else{
                let progress = 0;
                self.setState({progress});
                clearTimeout(timer);
                return;
            }
            timer = setTimeout(f,100);
        },100)

    }
    drawGraph=(mesh)=>{
        d3.select(".mySvg").remove();
        let nodes = mesh.nodes;
        let links = mesh.links;
        let allWidth = window.getComputedStyle(d3.select(".graphDraw").node()).width
        allWidth = Number(allWidth.replace("px",""));
        let allHeight = window.getComputedStyle(d3.select(".graphDraw").node()).height
        allHeight = Number(allHeight.replace("px",""));
        let margin = {top: 30, right: 30, bottom: 30, left: 30};
        let minScreen = allWidth > allHeight ? allHeight : allWidth;
        minScreen = minScreen < 5 ? 5 : minScreen; 
        let layoutHeight = minScreen*4/5;
        margin.right = (allWidth-layoutHeight)/2;
        margin.left = (allWidth-layoutHeight)/2;
        margin.top = (allHeight-layoutHeight)/2
        margin.bottom = (allHeight-layoutHeight)/2
        
        let width = layoutHeight;
        let height = layoutHeight;
        let map = {};
        let max=-Infinity, xmax = -Infinity;
        let min = Infinity, xmin=Infinity;
        nodes.forEach(e=>{
            if(e.y>max)max=e.y
            if(e.y<min)min=e.y
            if(e.x>xmax)xmax=e.x
            if(e.x<xmin)xmin=e.x
        })
        nodes.forEach(e=>{
            e.x=(e.x-xmin)/(xmax-xmin+0.0000001)*width;
            e.y=(e.y-min)/(max-min+0.000001)*height;
            map[e.id]={x:e.x, y:e.y}
        })
        const svg = d3.select(".graphDraw")
        .append("svg")
            .attr("class","mySvg")
            .attr("width", width + margin.left + margin.right)
            .attr("height", height + margin.top + margin.bottom)
        .append("g")
            .attr("transform",
            "translate(" + margin.left + "," + margin.top + ")");
        svg.selectAll("line")
            .data(links)
            .enter()
            .append("line")
                .attr("x1",d=>map[d.source].x)
                .attr("y1",d=>map[d.source].y)
                .attr("x2",d=>map[d.target].x)
                .attr("y2",d=>map[d.target].y)
                .style("stroke","rgba(150,150,150,1)")
                
        svg.selectAll("circle")
            .data(nodes)
            .enter()
            .append("circle")
                .attr("r",3)
                .style("fill","white")
                .style("stroke","RGBA(70,130,180,1)")
                .style("stroke-width",2)
                .attr("cx",d=>d.x)
                .attr("cy",d=>d.y)
    }

    resizeGraph = ()=>{
        let {data} = this.state;
        this.drawGraph(data)
    }
    componentDidMount(){
        //this.drawGraph(exampleData)
        this.drawGraph({nodes:[],links:[]})
        window.addEventListener("resize", this.resizeGraph);
    }
    componentWillUnmount(){
        window.removeEventListener("resize", this.resizeGraph);
    }
    render(){
        d3.select(".mySvg").remove();
        let {pending,progress} = this.state;
        return (
            <div className="graphDraw" style={{
                background:"rgb(255,255,255)",
                width:'calc(100vw - 650px)',
                height:'calc(100vh - 50px)',
                marginLeft:50,
                marginTop:0
            }}>
                {
                <Space size={"large"} style={{display:!pending?'none':'flex',width: "100%", height: "100%", alignItems: "center", justifyContent: "center", transform: "scale(3)"}}>
                    <Spin size="large"/>
                </Space> 
                // <Progress type="circle" percent={progress} format={percent => `${percent} %`} style={{display:!pending?'none':'flex',width: "100%", height: "100%",  alignItems: "center", justifyContent: "center",transform: "scale(2)"}}/>
                }
            </div>

            
        )
    }
}